export default {
  property: '/portal/propertyScoreboard',
  company: '/portal/companyScoreboard',
}
